import { useT } from '../i18n/LocaleProvider.js';

/**
 * 진입 화면.
 *
 * 브라우저 자동재생 정책상 소리 있는 영상은 자동 시작이 차단된다. **이 클릭 한 번이
 * 재생 권한을 준다** (`docs/06-frontend-spec.md` 「진입 흐름」). 화면을 하나 더 만드는
 * 것이 아니라 정책을 만족시키는 최소 장치다.
 *
 * ★ **v25 가 버튼을 하나 더 놓았다** — 「방송편성 보기」. 시작하기 **전에** 무엇이 있는지
 * 보고 고를 수 있어야 한다는 것이 그 요구이고, **고르면 바로 재생이 시작된다** —
 * 게이트로 되돌아오지 않는다.
 *
 * 그 카드 클릭이 **제스처**이므로 그 자리에서 `unlockBuffers()` 로 허가를 심는다
 * (v19 가 상품 화면의 `[방송 보기]` 를 위해 만든 그 함수) — 채널이 바뀌는 경우 실제
 * `start()` 는 `useEffect` 안이라 **제스처 밖**이기 때문이다.
 */
export function StartGate({
  onStart,
  onOpenGuide,
  resuming = false,
}: {
  onStart: () => void;
  /**
   * 편성표를 연다. `null` 이면 버튼을 그리지 않는다 — 채널 목록을 아직 못 받았을 때다.
   */
  onOpenGuide: (() => void) | null;
  /**
   * ★ **판매처에서 돌아왔다** (v21/F13). 문구만 갈린다.
   *
   * 설치된 앱에서는 외부로 나가는 **모든** 방법이 앱을 대체하므로(`left-for-checkout.ts`)
   * 이 게이트를 없앨 수 없다 — 소리 있는 재생은 제스처를 요구한다. 없앨 수 없는 것과
   * **오해를 주는 것은 다르다**: 채널과 지점은 이미 살아 있으니 「처음 보기」가 아니라
   * 「이어서 보기」다.
   */
  resuming?: boolean;
}) {
  const t = useT();
  return (
    <div className="gate">
      <h1 className="gate__title">BLOOM</h1>
      <p className="gate__hint">{t(resuming ? 'gate.hintResume' : 'gate.hint')}</p>
      <button
        type="button"
        className="gate__button"
        data-testid="start-watching"
        onClick={onStart}
        autoFocus
      >
        {t(resuming ? 'gate.startResume' : 'gate.start')}
      </button>
      {/*
        **시작 버튼 뒤에 둔다.** `entryFocusIndex` 는 기하가 아니라 **DOM 순서의 가장 앞**
        이라, 앞에 두면 리모컨의 첫 착지점이 「방송 보기」가 아니라 이쪽이 된다.
      */}
      {onOpenGuide !== null && (
        <button
          type="button"
          className="gate__button gate__button--ghost"
          data-testid="gate-open-guide"
          onClick={onOpenGuide}
        >
          {t('gate.openGuide')}
        </button>
      )}
    </div>
  );
}
